// src/pages/admin/sessions/AttendanceMark.jsx
import React from "react";
import MarkAttendance from "../../../components/attendance/MarkAttendance";

const AdminAttendanceMark = () => {
    return <MarkAttendance role="ADMIN" />;
};

export default AdminAttendanceMark;
